import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useFetch from '@/hooks/pure/useFetch';

const CompanyDetailRedirection = () => {
  const wc = useWorkspaceRouter();
  const { alias: companyAlias } = useParams();

  const handleRoute = useCallback(async () => {
    if (!companyAlias) return;

    wc.push('/companies', {
      replace: true,
    });
  }, [wc, companyAlias]);

  useFetch(handleRoute);

  return null;
};

export default CompanyDetailRedirection;
